import Vue from 'vue'
import $x from '../js/$x'
import init from '../js/init'
import publics from '../js/publicCall'
import router from '../router/router.js'
import popWin from '../js/utils/popWin.js'
import store from '../store'

import main from '../views/app.vue'
import {
    Button, Swipe, SwipeItem, Cell, CellGroup, Tabbar, TabbarItem, Tabs, Tab,
    Grid, GridItem, Icon, NavBar, Field, Calendar, Collapse, CollapseItem,
    Tag, DatetimePicker, Popup, Checkbox, TreeSelect, Overlay, ActionSheet,
    Skeleton, RadioGroup, Radio, Picker, Search, DropdownMenu, DropdownItem,
    Form, Loading, Popover, CheckboxGroup, Uploader, Slider, Circle,
    Dialog, Rate, Toast, Switch, Progress, List, PullRefresh
} from 'vant'

require('../fontokr/iconfont.css');
require('../css/index.scss');

// 仅对 npm run build-preview 时，使用客户端mock数据（拦截XMLHttpRequest）


Object.assign($x, publics)
// 通用组件，便于处理
Vue.prototype.$x = Vue.$x = $x;
Vue.prototype.$eventBus = new Vue();
// 常用组件在这注册。即可实现按需加载，又不必每个页面调用Vue.use。
Vue.use(Button).use(Checkbox).use(CheckboxGroup).use(Field).use(RadioGroup).use(Radio).use(Picker).use(Switch).use(Form)
    .use(Swipe).use(SwipeItem)
    .use(Cell).use(CellGroup)
    .use(Tabbar).use(TabbarItem)
    .use(Tabs).use(Tab)
    .use(Grid).use(GridItem)
    .use(Collapse).use(CollapseItem)
    .use(Calendar).use(DatetimePicker)
    .use(Popup).use(Overlay).use(Skeleton)
    .use(Icon).use(NavBar).use(Tag).use(TreeSelect).use(ActionSheet).use(Search)
    .use(DropdownMenu).use(DropdownItem).use(Loading).use(Popover)
    .use(DropdownMenu).use(DropdownItem).use(Loading).use(Uploader).use(Slider)
    .use(Dialog).use(Rate).use(Circle).use(Toast).use(Progress).use(List).use(PullRefresh);

Vue.use(popWin, router)
init().finally(() =>
    new Vue({
        el: '#app',
        router,
        store,
        render: h => h(main),
    })
)


